import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUserCircle } from '@fortawesome/free-solid-svg-icons';

import loading_gif from '../../../../images/balls.gif';

export default function SupervisorPill({
	supervisor,
	canRemove = false,
	onRemove = () => {},
	outer = true,
	innerStyle = null,
	children = null,
}) {
	const supervisor_saving = supervisor && supervisor.supervisor_saving;
	const adding_supervisor = supervisor_saving === 'add';
	const removing_supervisor = supervisor_saving === 'remove';
	const supervisor_name = adding_supervisor ? 'Adding supervisor...' : `${supervisor.last_name}, ${supervisor.first_name}`;

	const content = (
		<div className='department-supervisor-inner-container' style={innerStyle || undefined}>
			{adding_supervisor ?
				<img className='department-supervisor-saving-loader' src={loading_gif} alt='adding supervisor...' />
			: supervisor.img_url ?
				<img className='department-supervisor-img' src={require(`../../../../images/users/${supervisor.img_url}`)} alt='user' />
			:
				<FontAwesomeIcon className='department-supervisor-user-icon gray-text' icon={faUserCircle}/>
			}
			<div className='department-supervisor-name'>{supervisor_name}</div>
			{children}
			{canRemove && !adding_supervisor && (
				removing_supervisor ?
					<img className='department-supervisor-remove-loader' src={loading_gif} alt='removing supervisor...' />
				:
					<FontAwesomeIcon className='gray-text-hover' icon={faTimes} onClick={() => onRemove(supervisor.user_id)}/>
			)}
		</div>
	);

	if(!outer) return content;

	return (
		<div className='department-supervisor-outer-container'>
			{content}
		</div>
	);
}
